<template>
    <div>
        <h1>Thaipost EMS</h1>
        <el-row :gutter="20">
            <el-col :span="20" :offset="2">
                <el-card shadow="never" style="padding-bottom:20px;">
                    <el-row>
                        <el-col :span="8" class="text-md-left">
                            <el-input v-model="filters[0].value" placeholder="ค้นหาเลข Tracking" style="width:250px;"></el-input>
                            <el-button type="primary" @click="fetchThaipostEmsTracking" icon="el-icon-refresh">
                            </el-button>
                        </el-col>
                        <el-col :span="6" class="text-md-left">
                            <el-button type="primary" @click="showUpload">
                                <fa-icon name="file-excel"></fa-icon>&nbsp;Upload Tracking
                            </el-button>
                            <input type="file" ref="uploadTracking" style="display:none;" @change="onUploadTracking">
                        </el-col>
                        <el-col class="text-md-left" :span="10">
                            <p style="margin:0px;font-size:18px;">จำนวน Tracking ทั้งหมด : <b style="color:#339999;">{{ allTrackingCount }}</b></p>
                            <p style="margin:0px;font-size:18px;">จำนวน Tracking ที่ถูกใช้งานไปแล้ว : <b style="color:rgb(212, 46, 46);">{{ usedTrackingNumberCount }}</b></p>
                            <p style="margin:0px;font-size:18px;">จำนวน Tracking ที่พร้อมใช้งาน : <b style="color:#67C23A;">{{ trackingAvailable }}</b></p>
                            <p style="margin:0px;font-size:18px;">วันหมดอายุ : <b>{{ getExpireDate }}</b></p>
                        </el-col>
                    </el-row>
                    <el-row>
                        <data-tables
                            :data="trackingList"
                            :filters="filters"
                            class="dataTable"
                            :pagination-props="{ pageSizes: [10, 20, 50, 100] }"
                        >
                            <el-table-column type="index" width="50">
                            </el-table-column>
                            <el-table-column label="เลข Tracking" prop="trackingNumber">
                                <div class="text-md-left" slot-scope="scope">
                                      <a v-if="scope.row.orderId !== null" target="_blank" :href="'https://track.thailandpost.co.th/?trackNumber=' +  scope.row.trackingNumber">{{ scope.row.trackingNumber }}</a>
                                      <div v-else>{{ scope.row.trackingNumber }}</div>
                                </div>
                            </el-table-column>
                            <el-table-column label="ID เลขออเดอร์" prop="orderId">
                                <div class="text-md-left" slot-scope="scope">
                                      <a v-if="scope.row.orderId !== null" href="#" @click="handleOrderNumberDetail(scope.row.orderId)">{{ scope.row.orderId }}</a>
                                    <div v-else>-</div>
                                </div>
                            </el-table-column>
                            <el-table-column label="วันที่ใช้งานล่าสุด" prop="usedAt">
                                <div v-if="scope.row.usedAt" slot-scope="scope">{{ scope.row.usedAt | dayjs('format', 'YYYY-MM-DD HH:mm:ss') }}</div>
                                <div v-else>-</div>
                            </el-table-column>
                        </data-tables>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
// import xlsx from 'xlsx'

export default {
    name: 'ThaipostEmsTrackingManage',
    data () {
        return {
            trackingList: [],
            filters: [
                { prop: 'trackingNumber', value: '' }
            ],
            dateCreated: null
        }
    },
    created () {
        this.fetchThaipostEmsTracking()
    },
    computed: {
        allTrackingCount () {
            const countTracking = this.trackingList.length
            return countTracking
        },
        trackingAvailable () {
            const available = this.trackingList.filter(tracking => tracking.orderId === null).length
            return available
        },
        usedTrackingNumberCount () {
            const usedCount = this.trackingList.filter(tracking => tracking.usedAt !== null).length
            return usedCount
        },
        getExpireDate () {
            const dateExpired = this.dateCreated ? this.$dayjs(this.dateCreated).add(4, 'month').format('DD/MM/YYYY') : '-'
            return dateExpired
        }
    },
    methods: {
        showUpload () {
            this.$refs.uploadTracking.click()
        },
        async onUploadTracking (e) {
            let files = e.target.files
            let f = files[0]
            this.uploadFile = files[0]
            let parts = f.name.split('.')
            let ext = parts[parts.length - 1]
            if (ext !== 'csv') {
                this.$swal({
                    title: 'ผิดพลาด !',
                    text: 'ไฟล์ที่ต้องการอัพโหลดไม่ถูกต้อง',
                    type: 'error'
                })
                this.$refs.uploadTracking.value = ''
            } else {
                this.createMutiThaipostTracking()
            }
        },
        async fetchThaipostEmsTracking () {
            const dataloading = this.$loading({
                target: '.dataTable'
            })
            try {
                const res = await fgApi.courier.getAllThaipostTracking()
                if (res.success) {
                    this.trackingList = res.trackings ? [...res.trackings] : []
                    this.dateCreated = res.createAt
                } else {
                    this.trackingList = []
                    this.dateCreated = null
                }
            } catch (error) {
                console.log(error)
                this.$notify.error({
                    title: 'Error',
                    message: 'Get Thaipost-ems tracking error'
                })
            } finally {
                dataloading.close()
            }
        },
        async createMutiThaipostTracking () {
            this.$loading()
            try {
                console.log(this.uploadFile)
                const csvText = await this.uploadFile.text()
                console.log('file content', csvText)
                // const trackingList = csvText.replace(/\r\n|\n\r|\n|\r/g, ' ').split(' ')
                const trackingList = csvText.split(/\r\n/)
                const fillOutEmpty = trackingList.filter(tracking => tracking)
                const param = {
                    arr_tracking: [...fillOutEmpty]
                }
                const res = await fgApi.courier.createThaipostEmsTracking(param)
                if (res.success) {
                    this.$message({
                        type: 'success',
                        message: 'Upload completed'
                    })
                    if (res.trackingsError && res.trackingsError.length > 0) {
                        let groupErr = []
                        // let errText = ''
                        for (let index = 0; index < res.trackingsError.length; index++) {
                            if (groupErr.length > 0) {
                                let isHasSameError = groupErr.some(e => e.message === res.trackingsError[index].message)
                                if (isHasSameError) {
                                    groupErr.forEach(ge => {
                                        if (ge.message === res.trackingsError[index].message) {
                                            ge.tracking += `, ${res.trackingsError[index].tracking}`
                                        }
                                    })
                                } else {
                                    groupErr.push({
                                        message: res.trackingsError[index].message,
                                        tracking: res.trackingsError[index].tracking
                                    })
                                }
                            } else {
                                groupErr.push({
                                    message: res.trackingsError[index].message,
                                    tracking: res.trackingsError[index].tracking
                                })
                            }
                        }

                        let errText = '<div style="margin-top:10px;font-weight:bold">ไม่สามารถนำเข้า\nเลข Tracking ดังต่อไปนี้!</div>'
                        for (let index = 0; index < groupErr.length; index++) {
                            errText += `
                                <div class="text-left" style="margin-top:10px;font-weight:bold;font-size:18px">${groupErr[index].message}</div>
                                <div class="text-left" style="font-size:14px">เลข Tracking: ${groupErr[index].tracking}</div>
                            `
                        }

                        this.$swal({
                            title: 'เกิดข้อผิดพลาด!',
                            html: errText,
                            type: 'error'
                        })
                    }
                    this.fetchThaipostEmsTracking()
                }
            } catch (error) {
                console.log(error)
                this.$message({
                    type: 'success',
                    message: error
                })
            } finally {
                this.$refs.uploadTracking.value = ''
                this.$loading().close()
            }
        },
        handleOrderNumberDetail (orderNumber) {
            let route = this.$router.resolve({
                path: `/oms/logOrder/LogOrderDetail`,
                query: { orderId: orderNumber }
            })
            window.open(route.href, '_blank') // New tab
        }
    }
}
</script>
